import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { ConfigManagerService } from './config-manager.service';

@Injectable({
  providedIn: "root",
})
export class CatalogoService {
  constructor(private http: HttpClient, private configManagerService: ConfigManagerService) {}

  getDadosParceiro(codigoCatalogo: string, cnpj: string) {
    const api = this.configManagerService.obterConfig()?.API_CATALOGO;
    return this.http.get<any>(
      `${api}/GetParceiroCatalogo/${cnpj}/${codigoCatalogo}`
    );
  }

  getListaProdutos(codigoCatalogo: string, cnpj: string) {
    const api = this.configManagerService.obterConfig()?.API_CATALOGO;
    return this.http.get<any>(
      `${api}/GetListCatalogoProduto/${cnpj}/${codigoCatalogo}`
    );
  }
}
